module.exports = __webpack_public_path__ + "static/img/4-3.07a4f706.png";